export default __webpack_public_path__ + "static/media/authereum-shield.7ed79577.svg";